export function initHotelSingleMisc() {
    // ── Description expand ─────────────────────────────────────────────────
    document.addEventListener("click", (e) => {
        const expandBtn = e.target.closest("[data-dopline-expand-desc]");
        if (expandBtn) {
            const section = expandBtn.closest(".dl-card");
            const more = section
                ? section.querySelector(".dopline-hotel-single__desc-more")
                : null;
            if (more) {
                more.hidden = false;
                expandBtn.style.display = "none";
            }
            return;
        }

        // ── Facilities modal open ──────────────────────────────────────────
        if (e.target.closest("[data-dopline-facilities-open]")) {
            openFacilitiesModal();
            return;
        }

        // ── Facilities modal close ─────────────────────────────────────────
        if (e.target.closest("[data-dopline-facilities-close]")) {
            closeFacilitiesModal();
        }
    });

    // Close on Escape
    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
            closeFacilitiesModal();
        }
    });
}

function openFacilitiesModal() {
    const modal = document.getElementById("dopline-facilities-modal");
    if (!modal) return;
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";

    // Focus first focusable element
    const first = modal.querySelector("button, [tabindex]");
    if (first) first.focus();
}

function closeFacilitiesModal() {
    const modal = document.getElementById("dopline-facilities-modal");
    if (!modal || !modal.classList.contains("is-open")) return;
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
}
